<div class="wrapper" #wrapper>
  <app-general-header [isMobile]="isMobile$ | async"></app-general-header>

  <section
    *ngIf="!isLoading"
    class="anonymous"
    aria-label="main"
    role="main"
    id="main-content"
  >
    <div class="flex flex-col p-6 gap-6 items-center justify-center mt-6">
      <div class="w-20 h-20 text-black dark:text-white">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
        >
          <g mask="url(#mask0_5437_30319)">
            <path
              d="M40.0001 56.6665C40.9445 56.6665 41.7362 56.3471 42.3751 55.7082C43.014 55.0693 43.3334 54.2776 43.3334 53.3332C43.3334 52.3887 43.014 51.5971 42.3751 50.9582C41.7362 50.3193 40.9445 49.9998 40.0001 49.9998C39.0556 49.9998 38.264 50.3193 37.6251 50.9582C36.9862 51.5971 36.6667 52.3887 36.6667 53.3332C36.6667 54.2776 36.9862 55.0693 37.6251 55.7082C38.264 56.3471 39.0556 56.6665 40.0001 56.6665ZM40.0001 43.3332C40.9445 43.3332 41.7362 43.0137 42.3751 42.3748C43.014 41.736 43.3334 40.9443 43.3334 39.9998V26.6665C43.3334 25.7221 43.014 24.9304 42.3751 24.2915C41.7362 23.6526 40.9445 23.3332 40.0001 23.3332C39.0556 23.3332 38.264 23.6526 37.6251 24.2915C36.9862 24.9304 36.6667 25.7221 36.6667 26.6665V39.9998C36.6667 40.9443 36.9862 41.736 37.6251 42.3748C38.264 43.0137 39.0556 43.3332 40.0001 43.3332ZM40.0001 73.3332C35.389 73.3332 31.0556 72.4582 27.0001 70.7082C22.9445 68.9582 19.4167 66.5832 16.4167 63.5832C13.4167 60.5832 11.0417 57.0554 9.29175 52.9998C7.54175 48.9443 6.66675 44.611 6.66675 39.9998C6.66675 35.3887 7.54175 31.0554 9.29175 26.9998C11.0417 22.9443 13.4167 19.4165 16.4167 16.4165C19.4167 13.4165 22.9445 11.0415 27.0001 9.2915C31.0556 7.5415 35.389 6.6665 40.0001 6.6665C44.6112 6.6665 48.9445 7.5415 53.0001 9.2915C57.0556 11.0415 60.5834 13.4165 63.5834 16.4165C66.5834 19.4165 68.9584 22.9443 70.7084 26.9998C72.4584 31.0554 73.3334 35.3887 73.3334 39.9998C73.3334 44.611 72.4584 48.9443 70.7084 52.9998C68.9584 57.0554 66.5834 60.5832 63.5834 63.5832C60.5834 66.5832 57.0556 68.9582 53.0001 70.7082C48.9445 72.4582 44.6112 73.3332 40.0001 73.3332ZM40.0001 66.6665C47.4445 66.6665 53.7501 64.0832 58.9168 58.9165C64.0834 53.7498 66.6668 47.4443 66.6668 39.9998C66.6668 32.5554 64.0834 26.2498 58.9168 21.0832C53.7501 15.9165 47.4445 13.3332 40.0001 13.3332C32.5556 13.3332 26.2501 15.9165 21.0834 21.0832C15.9167 26.2498 13.3334 32.5554 13.3334 39.9998C13.3334 47.4443 15.9167 53.7498 21.0834 58.9165C26.2501 64.0832 32.5556 66.6665 40.0001 66.6665Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </div>
      <h1
        class="text-2xl lg:text-3.5xl text-black dark:text-white font-bold text-center"
      >
        {{ 'emailSent.linkExpired' | translate }}
      </h1>
      <ng-container *ngIf="!hideResend || timeLeft === 0; else emailResent">
        <button
          (click)="onResendEmail()"
          class="text-white rounded-full px-8 py-4 bg-blue-dark text-base font-bold"
        >
          {{ 'emailSent.resendLink' | translate }}
        </button>
        <div class="flex gap-2 items-center flex-center py-2">
          <span class="w-6 h-6 text-black dark:text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M10.75 5.75L11.375 4.5L12.625 3.875L11.375 3.25L10.75 2L10.125 3.25L8.875 3.875L10.125 4.5L10.75 5.75ZM5.125 8.25L6.16641 6.1668L8.25 5.125L6.16641 4.0832L5.125 2L4.08359 4.0832L2 5.125L4.08359 6.1668L5.125 8.25ZM18.875 13.25L17.8336 15.3332L15.75 16.375L17.8336 17.4168L18.875 19.5L19.9164 17.4168L22 16.375L19.9164 15.3332L18.875 13.25ZM21.6336 5.68086L18.3191 2.36641C18.0754 2.12187 17.7555 2 17.4355 2C17.1156 2 16.7957 2.12187 16.5516 2.36641L2.36641 16.5516C1.87813 17.0398 1.87813 17.8312 2.36641 18.3191L5.68086 21.6336C5.925 21.8777 6.24492 21.9996 6.56445 21.9996C6.88438 21.9996 7.2043 21.8777 7.44844 21.6336L21.6336 7.44805C22.1219 6.96055 22.1219 6.16875 21.6336 5.68086ZM16.041 9.94766L14.0523 7.95898L17.4352 4.57617L19.4238 6.56484L16.041 9.94766Z"
                fill="currentColor"
              />
            </svg>
          </span>
          <p class="text-black dark:text-white">
            {{
              'emailSent.clickLink' | translate : { email: this.endUser?.email }
            }}
          </p>
        </div>
      </ng-container>
      <p class="error-popover-msg text-error text-sm" *ngIf="isError">
        {{ errorMsg }}
      </p>
      <ng-template #emailResent>
        <div class="flex justify-center items-center gap-2 py-2 mb-6 lg:mx-11">
          <div class="w-6 h-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.2667 7.9L8.69167 11.4833L7.31667 10.1083C7.11302 9.87052 6.79324 9.76693 6.48882 9.84016C6.18441 9.91339 5.94672 10.1511 5.8735 10.4555C5.80027 10.7599 5.90386 11.0797 6.14167 11.2833L8.10001 13.25C8.25727 13.406 8.47017 13.493 8.69167 13.4917C8.91029 13.4908 9.11979 13.404 9.27501 13.25L13.4417 9.08334C13.5994 8.92686 13.6882 8.71387 13.6882 8.49167C13.6882 8.26947 13.5994 8.05647 13.4417 7.9C13.1166 7.5769 12.5917 7.5769 12.2667 7.9ZM10 2.2417C5.39765 2.2417 1.66669 5.97266 1.66669 10.575C1.66669 15.1774 5.39765 18.9084 10 18.9084C14.6024 18.9084 18.3334 15.1774 18.3334 10.575C18.3334 8.36489 17.4554 6.24528 15.8926 4.68248C14.3298 3.11967 12.2102 2.2417 10 2.2417ZM10 17.2416C6.31813 17.2416 3.33337 14.2568 3.33337 10.5749C3.33337 6.89303 6.31813 3.90826 10 3.90826C13.6819 3.90826 16.6667 6.89303 16.6667 10.5749C16.6667 12.343 15.9643 14.0387 14.7141 15.289C13.4638 16.5392 11.7681 17.2416 10 17.2416Z"
                fill="#68C97F"
              />
            </svg>
          </div>
          <p class="text-black dark:text-white text-sm font-medium">
            {{
              'emailSent.weResendEmail' | translate : { time: minutesLeft() }
            }}
          </p>
        </div>
      </ng-template>
    </div>
  </section>
</div>
<section class="footer-container pb-2.5 sm:pb-0">
  <app-general-footer id="main-footer"></app-general-footer>
</section>
